import { CPWX_PRODUCT_TYPE } from '.';

export const DEFAULT_TEXT = '--';

export const NO_CONFIG_PRODUCTS = [CPWX_PRODUCT_TYPE];

// 升级裸盘之后跳转的链接
export const UPDATE_BARE_DISK_RES_LINKS = {
  // 未申请
  3: '/income/device/bare-disk',
  // 排队中
  1: '/income/device/queue',
  // 升级中
  2: '/income/device/updating',
};

export const REPORT_DATA = {
  page_name: 'device_detail',
};

// 弹出硬盘
export const DEVICE_MENU_EJECT = 1;
// 移除设备
export const DEVICE_MENU_REMOVE = 2;
// 移动分组
export const DEVICE_MENU_GROUP = 3;
// 修改备注
export const DEVICE_MENU_REMARK = 4;
// 升级裸盘
export const DEVICE_MENU_BARE_DISK = 5;

export const DEVICE_MENU_BARE_DISK_ITEM = {
  name: '升级裸盘',
  id: DEVICE_MENU_BARE_DISK,
};
export const DEVICE_MENU_EJECT_ITEM = {
  name: '弹出硬盘',
  id: DEVICE_MENU_EJECT,
};

export const DEFAULT_MENU_LIST = [
  {
    name: '修改备注',
    id: DEVICE_MENU_REMARK,
  },
  {
    name: '移动分组',
    id: DEVICE_MENU_GROUP,
  },
  {
    name: '移除设备',
    id: DEVICE_MENU_REMOVE,
  },
];

export const DEFAULT_DEVICE_DETAIL_INFO = {
  yIncome: DEFAULT_TEXT,
  totalIncome: DEFAULT_TEXT,
  updateTime: DEFAULT_TEXT,
  baseInfo: {
    // diskUnmountable: 0,
    // lvmAble: 0,
  },
  cpuInfo: {},
  diskDetail: [],
  netInfo: {},
  ramInfo: {},
};

export const DEVICE_ONLINE_STATUS = {
  0: '离线',
  1: '在线',
  2: '异常',
};

export const TIME_FORMAT = 'MM-DD HH:mm';

// nat类型
export const DEVICE_NAT_INDICATOR = 'natType';
// nat稳定性
export const DEVICE_NAT_STABLE_TYPE_INDICATOR = 'natStable';
// 在线时长
export const DEVICE_ONLINE_TIME_INDICATOR = 'netOnline';
// 晚高峰在线率
export const DEVICE_EVENING_PEAK_RATE_INDICATOR = 'nightOnline';
// 丢包
export const DEVICE_PING_LOST_INDICATOR = 'loss';
// 时延
export const DEVICE_PING_RTT_INDICATOR = 'rtt';
// upnp
export const DEVICE_UPNP_INDICATOR = 'upnp';
// ip
export const DEVICE_IP_INDICATOR = 'ip';
// ipv6
export const DEVICE_IPV6_INDICATOR = 'ipv6';
// cpu
export const DEVICE_CPU_INDICATOR = 'cpu';
// mem
export const DEVICE_MEM_INDICATOR = 'mem';
// 磁盘类型
export const DEVICE_DISK_TYPE_INDICATOR = 'diskType';
// 磁盘空间
export const DEVICE_DISK_SPACE_INDICATOR = 'diskSpace';
// 文件系统类型
export const DEVICE_FS_TYPE_INDICATOR = 'fsType';
// 文件系统(容器设备)类型
export const DEVICE_DC_FS_TYPE_INDICATOR = 'fsTypeDC';
// 设备磁盘指标
export const DEVICE_DISK_FS_INDICATOR = `${DEVICE_DISK_TYPE_INDICATOR},${DEVICE_FS_TYPE_INDICATOR}`;
// 容器设备设备磁盘指标
export const DEVICE_DC_DISK_FS_INDICATOR = `${DEVICE_DISK_TYPE_INDICATOR},${DEVICE_DC_FS_TYPE_INDICATOR}`;

export const DEVICE_INDICATOR_MODAL_TYPES = [
  DEVICE_NAT_INDICATOR,
  DEVICE_PING_LOST_INDICATOR,
  DEVICE_PING_RTT_INDICATOR,
  DEVICE_UPNP_INDICATOR,
  DEVICE_IP_INDICATOR,
  DEVICE_DISK_FS_INDICATOR,
  DEVICE_DC_DISK_FS_INDICATOR,
];

// 指标说明内容
export const DEVICE_INDICATOR_DESCRIPTION = {
  [DEVICE_NAT_INDICATOR]: {
    title: 'NAT类型说明',
    content: `<p style="color:#8b0000;">本指标数据更新会有1-30分钟的延迟。</p>
    <h3>指标解读：</h3>
    <p>NAT类型不同等级对应网络质量不同，建议设备直接PPPoE拨号得到公网地址以获取最优NAT，或路由器设置DMZ或开启UPNP以达到更优的NAT类型，开启后若仍没有改善，建议尝试如下操作：<br/>a、重启路由器；<br/>b、检查路由器性能，如性能不足请减少下联设备数并及时清理映射表；<br/>c、更换路由器或向运营商反馈；</p>`,
  },
  [DEVICE_UPNP_INDICATOR]: {
    title: 'UPNP说明',
    content: `<p style="color:#8b0000;">本指标数据更新会有1-30分钟的延迟。</p><h3>指标解读：</h3><p>通过调整路由器UPNP“开/关”状态，可对应设备不同状态，请开启路由器UPNP以改善可用状态；</p>`,
  },
  [DEVICE_PING_LOST_INDICATOR]: {
    title: '丢包率说明',
    unitText: '（百分比）',
    content: `<p style="color:#8b0000;">本指标数据更新会有1-10分钟的延迟。</p><h3>指标解读：</h3><p>丢包是指设备数据由于某种原因被丟弃，常见于晚高峰网络拥塞情况。建议增加上行带宽或优化路由器/光猫性能，以提高网络质量；</p>`,
  },
  [DEVICE_PING_RTT_INDICATOR]: {
    title: '时延说明',
    unitText: '（毫秒）',
    content: `<p style="color:#8b0000;">本指标数据更新会有1-10分钟的延迟。</p><h3>指标解读：</h3><p>时延是指设备传输数据所需的时间，延时过大常见于晚高峰网络拥塞。建议增加上行带宽或优化路由器/光猫性能，以提高网络质量；</p>`,
  },
  [DEVICE_IP_INDICATOR]: {
    title: '外网IP',
    content: `<h3>指标解读：</h3><p>a、外网地址显示的为拨号设备获取到的出口公网IP，并非为网心云设备获取到的公网IP；</p><p>b、设备是否获取公网IP请查看NAT类型，卓越公网型则该地址显示的为该设备的公网IP地址；若NAT类型不是卓越公网型，则该地址显示为拨号设备获取到的出口公网IP；</p>`,
  },
  [DEVICE_DISK_FS_INDICATOR]: {
    title: '磁盘类型说明',
  },
  [DEVICE_DC_DISK_FS_INDICATOR]: {
    title: '磁盘类型说明',
  },
  [DEVICE_DISK_TYPE_INDICATOR]: {
    content: `
      <p style="color:#8b0000;">磁盘信息数据更新延迟较大，当对磁盘进行插盘拔盘之类变更操作后，请耐心等待1-2小时再查看状态。</p>
      <h3>一、磁盘类型说明</h3>
      <h3>指标解读：</h3>
      <p>
      磁盘类型是指设备存储数据时使用的介质类型，主要分类如下，建议使用SSD；
      <br />
      SSD—固态硬盘以半导体状态做记忆介质，相对机械硬盘，读取速度更快
      <br />
      HDD—机械硬盘以磁做记忆介质
      <br />
      U盘—USB闪存驱动器，Flash芯片存储数据，即插即用便于携带但存储容量一般小于SSD/HDD
    </p>`,
  },
  [DEVICE_FS_TYPE_INDICATOR]: {
    content: `<h3>二、文件系统说明</h3><h3>指标解读：</h3><p>文件系统是指管理磁盘空间的文件系统类型，建议采用裸盘。非裸盘设备可通过【APP-设备详情-升级裸盘】进行升级（该过程需要一定时间，请耐心等待）或提供SN联系客服处理；</p>`,
  },
  [DEVICE_DC_FS_TYPE_INDICATOR]: {
    content: `<h3>二、文件系统说明</h3><h3>指标解读：</h3><p>文件系统是指管理磁盘空间的文件系统类型，建议采用XFS/BTRFS/EXT4/ZFS；</p>`,
  },
};

// 操作
// 复制
export const COPY_ACTION = 'copy';
// 加密
export const ENCRYPT_ACTION = 'encrypt';
// 返回上一页
export const GOBACK_ACTION = 'goback';
// 跳转页面
export const JUMP_PAGE_ACTION = 'jumpPage';
// modal框操作
export const MODAL_ACTION = 'openModal';

// 退出定向业务
export const EXIT_BIZ_ACTION = 'exitBiz';
// 退出结果
export const EXIT_RES_SUCCESS = 'exitSuccess';
// 坐享其成设备退出
export const EFFORTLESS_DEVICE_REMOVE = 'effortlessDeviceRemove';

export const DEVICE_DETAIL_PAGE_NAME = 'device_detail';

export const ACTION_MODAL_INFO = {
  [DEVICE_MENU_EJECT]: {
    title: '确定弹出硬盘？',
    content: '弹出后设备无法继续产生收益',
  },
  [DEVICE_MENU_REMOVE]: {
    title: '确定移除设备？',
    content: '移除后无法管理设备以及查看收益',
  },
};

export const DEVICE_ACTION_MODAL_TYPES = [DEVICE_MENU_EJECT, DEVICE_MENU_REMOVE];

// 解绑短信场景
export const UNBIND_SMS_SCENE = 600;
// 退出定向业务短信场景
export const QUIT_RECRUIT_SMS_SCENE = 601;

export const PEAK_OPTIONS = [
  { key: 1, value: 'none', label: '不限时段' },
  { key: 2, value: 'evening_peak', label: '纯跑晚高峰（18:00-24:00）' },
  { key: 3, value: 'noon_peak', label: '纯跑午高峰+晚高峰' },
];
